import { locale } from "localization/en";

export const VoidPaymentValue = {
  DidNotIntendToPayViaPeso: locale.michargedDidNotIntendtoPayViaLocqpay,
  WrongAmountInput: locale.michargedWrongAmountInput,
  Others: locale.others,
};

export default VoidPaymentValue;
